
































































































import { Component, Vue } from 'vue-property-decorator';
import CommonButton from '@/components/common/CommonButton.vue';
import ResendSignUpModal from '@/components/register/ResendSignUpModal.vue';
import { Auth } from 'aws-amplify';

@Component({
  components: {
    CommonButton,
    ResendSignUpModal,
  },
})
export default class ConfirmSignUpBase extends Vue {
  private accountName = '';
  private confirmCode = '';
  private message = '';
  private isOpenResendSignUpModal = false;

  private isShowLeft() {
    if (this.$vuetify.breakpoint.width < 1200) {
      return false;
    }
    return true;
  }

  private col() {
    if (this.$vuetify.breakpoint.width < 1200) {
      return '12';
    }
    return '8';
  }

  private setMessage(message: string): void {
    this.message = message;
  }

  private async confirm() {
    if (!this.validateConfirmSignUpParam()) {
      return;
    }
    await this.onConfirmSignUp();
  }

  private async onConfirmSignUp() {
    try {
      await Auth.confirmSignUp(this.accountName, this.confirmCode);
      this.$router.push({ name: 'login' });
    } catch (error) {
      if (error.code) {
        switch (error.code) {
          case 'CodeMismatchException':
            this.setMessage('無効なコードです。');
            break;
          case 'LimitExceededException':
            this.setMessage('コードの送信可能回数が上限に達しました。');
            break;
          case 'ExpiredCodeException':
            this.setMessage('期限切れのコードです。');
            break;
          case 'NotAuthorizedException':
            this.setMessage('既に有効化されているコードです。');
            break;
          case 'CodeDeliveryFailureException':
            this.setMessage('コードの送信に失敗しました。');
            break;
          default:
            this.setMessage('予期しないエラーが発生しました。');
            break;
        }
      } else {
        this.setMessage('予期しないエラーが発生しました。');
      }
    }
  }

  private openResendSignUpModal() {
    this.isOpenResendSignUpModal = true;
  }

  private closeResendSignUpModal() {
    this.isOpenResendSignUpModal = false;
  }

  private validateConfirmSignUpParam() {
    if (this.accountName === '' || this.confirmCode === '') {
      this.setMessage('アカウント名、確認コードは必須です。');
      return false;
    } else {
      this.setMessage('');
      return true;
    }
  }
}
